var map = {
	"./defipulse.png": 423,
	"./discord.svg": 424,
	"./discord_white.svg": 259,
	"./gitbook.svg": 425,
	"./github.svg": 426,
	"./medium.svg": 427,
	"./telegram.svg": 428,
	"./twitter.svg": 429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 906;